import {
    TableViewStore,
    BaseListViewStore,
    QueryPickerStore,
    BaasicDropdownStore,
} from "core/stores";
import { WoundOrderService } from "application/wound-order/services";
import _ from "lodash";
import { toDate } from "core/utils";
import { action, observable } from "mobx";
import { FacilityService } from "../../facility/services";
import { WoundPatientService } from "../../wound-patient/services";
import { LookupService } from "common/services";

class WoundOrderListViewStore extends BaseListViewStore {
    @observable accessor counter = 0;
    constructor(rootStore) {
        const woundOrderService = new WoundOrderService(
            rootStore.application.baasic.apiClient
        );
        const facilityService = new FacilityService(
            rootStore.application.baasic.apiClient
        );
        const woundPatientService = new WoundPatientService(
            rootStore.application.baasic.apiClient
        );
        const lookupService = new LookupService(
            rootStore.application.baasic.apiClient
        );

        super(rootStore, {
            autoInit: true,
            name: "wound-order",
            routes: {
                create: () =>
                    rootStore.routerStore.goTo(
                        "master.app.main.wound-order.create"
                    ),
                edit: (id) => {
                    let selectedItem = null;
                    this.setChildNavigationTitle(
                        (i) => i.id === id,
                        (item) => {
                            selectedItem = item;
                            return item.name;
                        }
                    );
                    return this.rootStore.routerStore.goTo(
                        "master.app.main.wound-order.add-wound-dressing",
                        {
                            id: id,
                            hasCompletedCalculation:
                                selectedItem.hasCompletedCalculation,
                            hasCompletedAdditionalValidations:
                                selectedItem.hasCompletedAdditionalValidations,
                            hasCompletedDressingComboValidation:
                                selectedItem.hasCompletedDressingComboValidation
                        }
                    );
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await woundOrderService.find({
                            ...params,
                            embed: "WoundPatient,Facility,WoundOrderStatus",
                        });

                        const responseData = _.extend(response.data, {
                            item: _.map(response.data.item, (item) => {
                                return _.extend(item, {
                                    woundOrderStatusName:
                                        item.woundOrderStatusName,
                                    woundPatient: item.patientName,
                                    facilityName: item.facilityName,
                                    dateOfService: toDate(item.dateOfService),
                                    dateCreated: toDate(item.dateCreated),
                                    assessmentDate: toDate(item.assessmentDate),
                                });
                            }),
                        });
                        return responseData;
                    },
                };
            },
        });

        this.dateOfServicePickerStore = new QueryPickerStore();

        this.woundOrderStatuses = null;

        this.queryUtility.onResetFilter = () => {
            this.facilityStore.setValue(null);
            this.facilityStore.filterTerm = "";

            this.woundPatientStore.setValue(null);
            this.woundPatientStore.filterTerm = "";

            this.woundOrderStatusStore.setValue(null);

            this.dateOfServicePickerStore.reset();
        };

        this.facilityStore = new BaasicDropdownStore(
            {
                filterable: true,
            },
            {
                fetchFunc: async (term) => {
                    const response = await facilityService.find({
                        searchQuery: term,
                        rpp: 100,
                    });
                    return _.map(response.data.item, (item) => {
                        return {
                            id: item.id,
                            name: item.name,
                        };
                    });
                },
            }
        );

        this.woundPatientStore = new BaasicDropdownStore(
            {
                filterable: true,
            },
            {
                fetchFunc: async (term) => {
                    const response = await woundPatientService.find({
                        searchQuery: term,
                        rpp: 100,
                    });
                    return _.map(response.data.item, (item) => {
                        return {
                            id: item.id,
                            name: `${item.firstName} ${item.lastName}`,
                        };
                    });
                },
            }
        );

        this.woundOrderStatusStore = new BaasicDropdownStore(
            {
                filterable: false,
                textField: "name",
                dataItemKey: "id",
            },
            {
                fetchFunc: async () => {
                    const response = await lookupService.getLookups(
                        "WoundOrderStatus"
                    );
                    return response.woundOrderStatus;
                },
            }
        );

        this.setTableStore(
            new TableViewStore(this.queryUtility, {
                columns: [
                    {
                        key: "woundPatient",
                        title: "Patient",
                    },
                    {
                        key: "facilityName",
                        title: "Facility",
                    },
                    {
                        key: "dateOfService",
                        title: "Date Of Service",
                        width: 150,
                    },
                    {
                        key: "dateCreated",
                        title: "Date Created",
                        width: 150,
                    },
                    {
                        key: "woundOrderStatusName",
                        title: "Status",
                        width: 150,
                    },
                ],
                actions: {
                    onEdit: (item) => this.routes.edit(item.id),
                },
            })
        );
    }

    @action.bound
    filterOnChange() {
        this.queryUtility.fetch();
    }
}

export default WoundOrderListViewStore;
